// extracted by mini-css-extract-plugin
export var displayNone = "_rk-6";
export var imgContainer = "_rk-2";
export var overflowHidden = "_rk-3";
export var productInfoCardButtonContainer = "_rk-5";
export var productTitleText = "_rk-4";
export var rightArrow = "_rk-1";
export var rightArrowContainer = "_rk-0";